import { createContext } from 'react';

export interface RowContextType {
  gutter?: [number, number];
  wrap?: boolean;
}

export const RowContext = createContext<RowContextType>({});
